import { createSelector } from '@ngrx/store';

import {
  selectProduct,
  selectProducts,
  selectProductLoading,
  selectProductsLoading,
  selectProductError,
  selectQuantityPerProduct,
  selectInventoryCountPerDestinationAndProduct,
  selectProductInventoryLoading,
} from '../core/reducers/product.reducer';

export const getProduct = selectProduct;
export const getProductLoading = selectProductLoading;
export const getProducts = selectProducts;
export const getProductsLoading = selectProductsLoading;
export const getProductError = selectProductError;
export const getProductQuantity = createSelector(
  selectQuantityPerProduct,
  quantityPerProduct => (productId: number) => quantityPerProduct[productId],
);
export const getProductInventoryCount = selectInventoryCountPerDestinationAndProduct;
export const getProductInventoryCountLoading = selectProductInventoryLoading;
